import React, { ChangeEvent, useEffect, useState } from 'react'
import SubCover from '../../SubCover/SubCover'
import {Button, FormField, Loader, SubmitModal} from '../..'
import toast from 'react-hot-toast'
import { actionUpdateAdmin } from '../../../actions/admins'
import { adminValidateEmailAddress } from '../../validations/admins/register'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../../reducers/store'
import { create } from '../../../assets'

import './editAdminEmail.css'

interface PostDataParams {
  emailAddress: string;
}

const EditAdminEmail = ({id, details}: any) => {
  const pageName                                     = "Edit Admin"
  const dispatch                                     = useDispatch<AppDispatch>();
  const [savingInfo, setSavingInfo]                  = useState<boolean>(false);
  const [onOpen, setOnOpen]                          = useState<boolean>(false);
  const [emailAddressErrors, setEmailAddressErrors]  = useState<string[]>([]);
  const [openSubMegaMenu, setOpenSubMegaMenu]        = useState<boolean>(false);
  const [isButtonDisabled, setIsButtonDisabled]      = useState<boolean>(true);
  const [errorMessage, setErrorMessage]              = useState<string>();
  const { getAllAdmins, currentPage }                = useSelector((state: RootState) => state.adminList);

  const [postData, setPostData]                   = useState<PostDataParams>({emailAddress: details?.emailAddress || ''})
  const [isLoadingBtn, setIsLoadingBtn]           = useState({emailAddress: false});
  const [isValid, setIsValid]                     = useState({emailAddress: false});

  const useDebounce = <T,>(value: T, delay: number): T => {
    const [debounced, setDebounced] = useState(value);
  
    useEffect(() => {
      const handler = setTimeout(() => {
        setDebounced(value);
      }, delay);
      return () => clearTimeout(handler);
    }, [value, delay]);
  
    return debounced;
  };

  const debouncedPostData = useDebounce<PostDataParams>(postData, 500);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setIsLoadingBtn((prevState) => ({ ...prevState, [name]: true }));
    setPostData((prevState) => ({ ...prevState, [name]: value }));
  }

  // useEffect(() => {
  //   dispatch(actionFetchAdmins({currentPage})); // You can pass the page number as needed
  // }, [dispatch, currentPage]);

  useEffect(() => {
  
    const validateEmailAddress = () => {
      const { isValid, errors } = adminValidateEmailAddress({ postData: debouncedPostData, getAllAdmins });
      setIsValid((prevState) => ({
        ...prevState,
        emailAddress: isValid,
      }));
      setEmailAddressErrors(errors)
      setIsLoadingBtn((prevState) => ({
        ...prevState,
        emailAddress: false,
      }));
      return errors;
    };

    const emailAddressErrors     = validateEmailAddress();
    
    setEmailAddressErrors(emailAddressErrors);

    const hasFormErrors = emailAddressErrors.length > 0;
    setIsButtonDisabled(hasFormErrors);
  }, [debouncedPostData]);

  const handleModalSubmit = () => {
    setOnOpen(true)
    setOpenSubMegaMenu(true)
  }

  const handleCloseCover = () => {
    setOnOpen(false) // modal
    setOpenSubMegaMenu(false)
  }

  const handleSubmit = async(e: ChangeEvent<any>) => {
    e.preventDefault();
    handleModalSubmit()
  }

  const cancelPostCreation = () => {
    setOnOpen(false); // Close the modal
    setSavingInfo(false);
    setOpenSubMegaMenu(false)
  };

  const confirmPostCreation = async() => {
    setSavingInfo(true);
    setIsButtonDisabled(true);
    const res = await dispatch(actionUpdateAdmin({id, postData}))
    try{
      if (res.success === true) {
        toast.success("user updated successfully");
        setPostData({ emailAddress: res?.data?.emailAddress || ''})
        setSavingInfo(false);
      } else if (res?.status === 500) {
        setErrorMessage(res?.message);
        setSavingInfo(false)
      }
    }catch(error: any){
      setErrorMessage("Internal server Error")
      setSavingInfo(false)
    }
  }

  return (
    <>
      <title>{pageName}</title>
      <div className='edit-detail-admin-email-container'>
        <form className='' onSubmit={handleSubmit} autoComplete="off" >
          <div className='edit-detail-admin-email-title'>
            <h3>update Admin Email Address</h3>
          </div>

          <div className=''>
            <FormField inputType type="text" labelName="Email Address" name="emailAddress" value={postData.emailAddress} handleChange={handleChange} isLoadingBtn={isLoadingBtn.emailAddress} isValid={isValid.emailAddress} errors={emailAddressErrors || []} />

            <SubmitModal onOpen={onOpen} onClose={cancelPostCreation} onConfirm={confirmPostCreation} modalImage={create} prompt="Are you sure you want to update admin" />
            <Button onClickButton buttonClickWrap={savingInfo ? `button-login-submitted` : `button-login-submit`} onClickName={savingInfo ? <>{<Loader />} updating data...</> : "Update Admin"} isButtonDisabled={isButtonDisabled} buttonClasses={savingInfo ? ['button-disabled'] : (isButtonDisabled ? ['buttonDisabledClass'] : ['buttonEnabledClass'])} disabled={savingInfo} />
            
            {errorMessage && (
              <div className="form-response-message">
              <p className="error-msg">{errorMessage}</p>
              </div>
            )}
          </div>
        </form>
      </div>

      {openSubMegaMenu && (
        //z-index: 3, others should be higher
        <SubCover handleCloseCover={handleCloseCover} />
      )}
    </>
  )
}

export default EditAdminEmail